"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upgrade/UpgradeModal/components/PlanCardTitle.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






const PlanCardTitle = ({ planName, orgName }) => (
  _react2.default.createElement('div', { className: "plan-modal--summary--info--title-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 9}}
    , _react2.default.createElement('h2', { className: "plan-modal--summary--info--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 10}},  planName )
    , _react2.default.createElement('div', { className: "plan-modal--summary--info--name-spacer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}} )
    , _react2.default.createElement('span', { className: "plan-modal--summary--info--org", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}},  orgName )
  )
)

exports. default = PlanCardTitle
